module.exports = __webpack_public_path__ + "static/img/PM103194.4148dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/PM103194.jpg
// module id = LCcY
// module chunks = 0